export default __webpack_public_path__ + "static/media/card-relationship.bf965844.png";